export default {
    add_comments: 'Add comments',
    ai_activities_employee_count: 'Number of employees dedicated to AI within the organization',
    ai_activities_project_count: 'Estimated number of AI projects completed',
    ai_activities_start_year: 'Year the organization started its AI activities',
    begin_validation: 'Start the validation',
    between_y_z: 'profiles between y and z',
    caption: 'Media Description',
    choices: {
        no: 'No, I would like to specify some things',
        yes: 'Yes, it is perfect!'
    },
    competences: 'Issues and needs addressed by the organization',
    contact: 'Organization\'s contact email',
    definitions: {
        expertises: 'Does this text accurately represent the mentioned expertise?',
        instruction: 'How can the proposed content better describe the offer?',
        knowledge: 'Does this definition accurately represent the expertise of the organization?',
        offer_description: 'Does this definition accurately represent the organization\'s offering?',
        partnership_benefits: 'Does this text accurately represent what a partner can expect to gain from collaborating with you?',
        placeholder: 'Describe to Miria how to modify the content as you would in a normal conversation.'
    },
    email: 'Email',
    expertises: 'Specific expertise',
    facebook: 'URL of the organization\'s Facebook page',
    feedback_message: '(Optional) Feel free to add details',
    file_select: 'Select a file',
    go_back: 'Go back to the platform',
    has_miria: 'Miria Profile',
    has_vitrine: 'Vitrine Profile',
    knowledge: 'Definition of expertise',
    linkedin: 'URL of the organization\'s LinkedIn page',
    logo: 'Organization\'s logo (must not exceed 200 KB)',
    miria_organizations_created: 'Profiles created on Miria',
    name: 'Name of the organization',
    offer_description: 'Offer description',
    or: 'or',
    organization_type: 'Organization Type',
    page_url: 'Page URL',
    partnership_benefits: 'Partnership benefits - Tangible results',
    preview: 'Preview',
    privacy_policy: 'Privacy Policy',
    searching: 'Please wait a few moments while I perform my search',
    status: 'Organization status',
    target_audiences: 'Audiences targeted by the organization',
    total_vitrine_profiles: 'Total Vitrine profiles',
    transferred: 'Transferred?',
    transferred_miria: 'Transferred Miria profiles',
    transferred_profiles: 'Transferred profiles',
    useful_response: 'Is this answer helpful to you?',
    website: 'URL of the organization\'s main website',
    x: 'URL of the organization\'s X page',
    x_days: '[X] days',
    youtube: 'URL of the video'
}